"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _PlaceholdersButton = _interopRequireDefault(require("../PlaceholdersButton/PlaceholdersButton"));

var PlaceholdersTextField = function PlaceholdersTextField(_ref) {
  var _onChange = _ref.onChange,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      placeholders = _ref.placeholders,
      textFieldProps = (0, _objectWithoutProperties2.default)(_ref, ["onChange", "disabled", "placeholders"]);
  var inputRef = (0, _react.useRef)(null);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    justifyContent: "flex-end",
    mb: 1
  }, /*#__PURE__*/_react.default.createElement(_PlaceholdersButton.default, {
    disabled: disabled,
    inputRef: inputRef,
    onChange: _onChange,
    placeholders: placeholders
  })), /*#__PURE__*/_react.default.createElement(_material.TextField, (0, _extends2.default)({}, textFieldProps, {
    disabled: disabled,
    inputRef: inputRef,
    onChange: function onChange(event) {
      return _onChange(event.target.value);
    }
  })));
};

var _default = PlaceholdersTextField;
exports.default = _default;